import React, { useState, useEffect } from 'react'
import L from 'leaflet'
import { addRouting } from './helpers'
import { fetchResponse } from '../../../controllers/shared/utils/fetch_data'

import 'leaflet/dist/leaflet.css'
import './style.scss'

export default function Route({ url, routeUpdatedEventName, graphHopperApiKey }) {
  const [wrapperDimensions, setWrapperDimensions] = useState({ height: '0', width: '0' })
  const [map, setMap] = useState(null)
  const [routing, setRouting] = useState(null)

  useEffect(async () => {
    const wrapper = document.getElementById('route-wrapper')
    if (wrapper) {
      setWrapperDimensions({ height: `${wrapper.clientHeight}px`, width: `${wrapper.clientWidth}px` })
    }

    const newMap = L.map('map')
    setMap(newMap)

    fetchRoutes({ forceMapRef: newMap })

    L.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
    }).addTo(newMap)
  }, [])

  useEffect(() => {
    window.addEventListener(routeUpdatedEventName, fetchRoutes)

    return () => {
      window.removeEventListener(routeUpdatedEventName, fetchRoutes)
    }
  }, [map, routing])

  const fetchRoutes = async function({ forceMapRef = null }) {
    const response = await fetchResponse(url)

    if (response.ok) {
      const json = await response.json()
      const routingElement = addRouting({ color: json.color, routeStops: [json.startingPoint, ...json.stops], graphHopperApiKey: graphHopperApiKey, mapRef: forceMapRef || map, routingElement: routing })
      setRouting(routingElement)

      return json.startingPoint
    }
  }

  return (
    <React.Fragment>
      <div id='map' style={{ height: wrapperDimensions.height, width: wrapperDimensions.width }} />
    </React.Fragment>
  )
}
